import { CategoryEnum } from '../../enums/category';

export const TEN_MINUTES: number = 10 * 60 * 1000;

export function getDraftStorageKey(
    categoryId: CategoryEnum,
    listingId: number,
    subCategory?: string
): string {
    return `draft_${categoryId}_${subCategory}_${listingId}`;
}

export function getTimestampStorageKey(
    categoryId: CategoryEnum,
    listingId: number,
    subCategory?: string
) {
    const draftKey = getDraftStorageKey(categoryId, listingId, subCategory);
    return `${draftKey}_timestamp`;
}

export function isTimestampExpired(timestamp: number): boolean {
    const now = Date.now();
    return now - timestamp > TEN_MINUTES;
}